export function getOrgId() {
  const orgId = JSON.parse(localStorage.getItem('orgId'))
  return orgId
}
